module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', _vm._b({
    staticClass: "ci-topbar",
    attrs: {
      "mode": _vm.showMode
    },
    on: {
      "select": _vm.select,
      "open": _vm.open,
      "close": _vm.close
    }
  }, 'el-menu', _vm.$props), [(_vm.titlename) ? _c('el-menu-item', {
    staticClass: "ci-topbar__title",
    attrs: {
      "index": "1"
    }
  }, [_vm._v(_vm._s(_vm.titlename))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.menuContentClass
  }, [_vm._l((_vm.data), function(item, index) {
    return (_vm.data) ? [(item.items) ? _c('el-submenu', {
      attrs: {
        "index": _vm.getIndex(index)
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.icon
    }), _vm._v(_vm._s(item.title))]), _vm._v(" "), _vm._l((item.items), function(menuItem, menuIndex) {
      return [(menuItem.items) ? _c('el-menu-item-group', {
        attrs: {
          "title": menuItem.title
        }
      }, _vm._l((menuItem.items), function(subItem, subIndex) {
        return _c('a', {
          key: subIndex,
          on: {
            "click": function($event) {
              _vm.startRouter(subIndex)
            }
          }
        }, [_c('el-menu-item', {
          attrs: {
            "index": _vm.getIndex(subIndex, index)
          }
        }, [_c('i', {
          class: subItem.icon
        }), _vm._v("\n                  " + _vm._s(subItem.title) + "\n              ")])], 1)
      })) : _c('a', {
        on: {
          "click": function($event) {
            _vm.startRouter(menuItem)
          }
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": _vm.getIndex(menuIndex, index)
        }
      }, [_c('i', {
        class: menuItem.icon
      }), _vm._v("\n                " + _vm._s(menuItem.title) + "\n              ")])], 1)]
    })], 2) : _c('a', {
      on: {
        "click": function($event) {
          _vm.startRouter(item)
        }
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": _vm.getIndex(index)
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v("\n            " + _vm._s(item.title) + "\n          ")])], 1)] : _vm._e()
  })], 2), _vm._v(" "), (_vm.username) ? _c('el-submenu', {
    class: _vm.userMenuClass,
    attrs: {
      "index": ("" + (_vm.data.length + 1))
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.loginOut
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": ((_vm.data.length + 2) + "-1")
    }
  }, [_vm._v("登出")])], 1)], 2) : _vm._e(), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.handleTopbar
    }
  }, [_c('el-menu-item', {
    staticClass: "ci-topbar__menu",
    attrs: {
      "index": ("" + (_vm.data.length + 2))
    }
  }, [_c('i', {
    class: _vm.handleMenuClass
  })])], 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1c95f502"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ci-components/components/topbar.vue
// module id = 251
// module chunks = 4